import React, { useState, useEffect } from "react";

const getStyles = () => {
  return {
    root: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
    },
    loader: {
      width: "25vh",
      height: "25vh",
    },
    loaderText: {
      fontSize: "1.5rem",
      fontWeight: "bold",
      color: "#000",
    },
  };
};

const Loader = (props) => {
  const [isLoading, setIsLoading] = useState(true);
  const classes = getStyles();
  useEffect(() => {
    setIsLoading(false);
  }, []);
  if (isLoading) {
    return (
      <div style={classes.root}>
        <img
          src="https://i.gifer.com/7YQl.gif"
          alt="loader"
          style={classes.loader}
        />
        <div style={classes.loaderText}>Loading...</div>
      </div>
    );
  }
  return <>{props.children}</>;
};

export default Loader;
